<template>
  <section :class="$style.container" data-luko-tracking="OptionContent">
    <Wrapper :class="$style.wrapper">
      <div data-aos="fade-up">
        <Title :class="$style.title" :title-params="primary.title" />
        <RichText
          v-if="primary.description"
          :class="$style.description"
          :text-params="primary.description"
        />
        <div :class="$style.optionMenu">
          <RichText
            v-if="primary.option_description"
            :class="$style.option_description"
            :text-params="primary.option_description"
          />
          <OptionMenu
            :items="items"
            :selected-option="selectedOption"
            @onSelect="onSelect"
          />
        </div>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'
import OptionMenu from '~/components/OptionMenu'

export default {
  name: 'LukonTerminationOptions',
  components: {
    Title,
    RichText,
    OptionMenu,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
    selectedOption: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
    }
  },
  methods: {
    onSelect(index) {
      this.$emit('onSelect', index)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 128px 24px 80px;
  @include below(small) {
    margin: 54px 24px 80px;
  }
}
.wrapper {
  width: 90%;
  max-width: 720px;

  text-align: center;
  .title {
    @include typo-extra-title;
    padding: 0 10px;

    color: $gray-1000;
    font-weight: 200;
    font-size: 40px;
    line-height: 56px;
  }
  .description {
    @include typo-body;
    color: $gray-700;
  }
  .option_description {
    @include typo-headline;
    margin: 40px 0;

    color: $gray-1000;
  }
  .optionMenu {
    @include below(small) {
      display: none;
    }
  }
}
</style>
